import { render, staticRenderFns } from "./IvrStep.vue?vue&type=template&id=d31147c6&"
import script from "./IvrStep.vue?vue&type=script&lang=ts&"
export * from "./IvrStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d31147c6')) {
      api.createRecord('d31147c6', component.options)
    } else {
      api.reload('d31147c6', component.options)
    }
    module.hot.accept("./IvrStep.vue?vue&type=template&id=d31147c6&", function () {
      api.rerender('d31147c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/IvrStep.vue"
export default component.exports